import React from 'react';
import { Link } from 'react-router-dom';
import '../css/topCategories.css';

const topCategoriesData = [
    {
        name: 'Electronics Accessories',
        link: '/category/electronics-accessories',
        image: '/images/icons/electronics.png'
    },
    {
        name: 'Home Essentials',
        link: '/category/home-essentials',
        image: '/images/icons/home-furniture.png'
    },
    {
        name: 'Personal Care',
        link: '/category/personal-care',
        image: '/images/icons/skin-care.png'
    },
    {
        name: 'Food & Beverages',
        link: '/category/food-&-beverages',
        image: '/images/icons/food.png'
    },
    {
        name: 'Pets Care',
        link: '/category/pets-care',
        image: '/images/icons/pet-food.png'
    },
    {
        name: 'SaaS',
        link: '/category/saaS',
        image: '/images/icons/saas.png'
    },
    {
        name: 'Gift Cards & Memberships',
        link: '/category/gift-card-&-memberships',
        image: '/images/icons/gift-card.png'
    },
];

const CategoryItem = ({ name, link, count, image }) => (
    <div className="col-category">
        <Link to={link} className="category-item text-decoration-none text-center">
            <div className="category-image-wrapper">
                <img src={image} alt={name} className="img-fluid category-image" />
            </div>
            <h6 className="category-name fw-bold mt-3 mb-0">{name}</h6>
            <p className="category-count text-muted small">{count}</p>
        </Link>
    </div>
);

export default function TopCategories() {
    return (
        <div className="container my-5 top-categories-section">
            <h3 className="section-title fw-bold mb-4">Our Top Categories</h3>

            {/* Horizontal row wrapper */}
            <div className="category-row">
                {topCategoriesData.map((item, index) => (
                    <CategoryItem
                        key={index}
                        name={item.name}
                        link={item.link}
                        image={item.image}
                    />
                ))}
            </div>
        </div>
    );
}